<script setup>
import { useGlobalStore } from "@stores/global.js";
import AnnouncementBar from "@components/global/AnnouncementBar.vue";
import Header from "@sections/global/Header.vue";
import Cart from "@components/global/Cart.vue";
import Footer from "@sections/global/Footer.vue";

const global = useGlobalStore();
</script>

<template>
	<div
		class="transition-colors duration-500"
	>
		<AnnouncementBar />
		<Header />
		<Cart />
		<router-view v-slot="{ Component, route }">
			<main class="min-h-screen">
				<component :is="Component" :key="route.path" />
			</main>
		</router-view>
		<Footer />
	</div>
</template>
